export default {
  locale: 'en',
  TableFilter: {
    resultLabel: 'Filter',
    expanse: 'Advance Filter',
    clear: 'Clear',
    emptyField: 'No Filter Field',
    total: 'Total of',
    totalInfo: 'result(s)',
  },
  Tag: {
    verifiedInvoice: 'Verified Receipt',
    freeInvoice: 'Receipt-Free',
    childFee: '子'
  },
  HelpComponent: {
    more: '更多',
  },
  FeeTypeInput : {
    none: 'None',
    placeholder:'Please Select',
  },
};
